import { createContext } from 'react';

const gruposContext = createContext();

export default gruposContext;